function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.5 2.5H3.50002C2.30002 2.5 1.40002 3.5 1.40002 4.6V21C1.40002 22.2 2.40002 23.1 3.50002 23.1H10.9L12.6 27.6H8.60002C8.40002 27.6 8.20002 27.8 8.20002 28C8.20002 28.2 8.40002 28.4 8.60002 28.4H13.2H17.7H22.3C22.5 28.4 22.7 28.2 22.7 28C22.7 27.8 22.5 27.6 22.3 27.6H18.3L20 23.1H27.4C28.6 23.1 29.5 22.1 29.5 21V4.6C29.6 3.4 28.7 2.5 27.5 2.5ZM3.50002 3.4H27.6C28.3 3.4 28.8 4 28.8 4.6V17.7H2.20002V4.6C2.20002 3.9 2.80002 3.4 3.50002 3.4ZM17.5 27.6H13.6L11.8 23.1H19.2L17.5 27.6ZM27.5 22.2H20C19.9 22.2 19.9 22.2 19.8 22.2H11.1C11 22.2 11 22.2 11 22.2H3.50002C2.80002 22.2 2.30002 21.6 2.30002 21V18.1H28.8V21C28.8 21.7 28.2 22.2 27.5 22.2Z",
  fill: "#1C33C8"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.1 19.1C11.5 19.1 11.1 19.6 11.1 20.1C11.1 20.7 11.6 21.1 12.1 21.1C12.7 21.1 13.1 20.7 13.1 20.1C13.2 19.6 12.7 19.1 12.1 19.1ZM12.1 20.8C11.8 20.8 11.5 20.5 11.5 20.2C11.5 19.9 11.8 19.6 12.1 19.6C12.4 19.6 12.7 19.9 12.7 20.2C12.7 20.5 12.5 20.8 12.1 20.8Z",
  fill: "#1C33C8"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5 19.1C14.9 19.1 14.5 19.6 14.5 20.1C14.5 20.7 15 21.1 15.5 21.1C16.1 21.1 16.5 20.7 16.5 20.1C16.5 19.6 16.1 19.1 15.5 19.1ZM15.5 20.8C15.2 20.8 14.9 20.5 14.9 20.2C14.9 19.9 15.2 19.6 15.5 19.6C15.8 19.6 16.1 19.9 16.1 20.2C16.1 20.5 15.8 20.8 15.5 20.8Z",
  fill: "#1C33C8"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.9 19.1C18.3 19.1 17.9 19.6 17.9 20.1C17.9 20.7 18.4 21.1 18.9 21.1C19.5 21.1 19.9 20.7 19.9 20.1C19.9 19.6 19.4 19.1 18.9 19.1ZM18.9 20.8C18.6 20.8 18.3 20.5 18.3 20.2C18.3 19.9 18.6 19.6 18.9 19.6C19.2 19.6 19.5 19.9 19.5 20.2C19.5 20.5 19.2 20.8 18.9 20.8Z",
  fill: "#1C33C8"
});

var SvgLed = function SvgLed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/led.a7cde829.svg";
export { ForwardRef as ReactComponent };